import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalPage() {
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center gap-3">
          <Link to="/" className="p-2 rounded-lg hover:bg-slate-100" aria-label="Retour">
            <ArrowLeft className="w-5 h-5 text-slate-600" />
          </Link>
          <h1 className="text-xl font-bold text-slate-900">Mentions légales</h1>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 prose prose-slate max-w-none">
        <p className="text-sm text-slate-500">Dernière mise à jour : 28 mai 2026</p>

        <section className="mt-6">
          <h2 className="text-lg font-bold text-slate-900 mt-6 mb-2">Éditeur du site</h2>
          <p>
            <strong>DoctoDays</strong><br />
            Société par Actions Simplifiée<br />
            Adresse : <em>(à compléter)</em><br />
            SIRET : <em>(à compléter)</em><br />
            RCS : <em>(à compléter)</em><br />
            N° TVA intracommunautaire : <em>(à compléter)</em><br />
            Directeur de la publication : <em>(à compléter)</em>
          </p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-slate-900 mt-6 mb-2">Hébergement</h2>
          <p>
            Application & API : Emergent Labs (hébergement européen)<br />
            Données médicales : à confirmer — hébergeur HDS certifié
          </p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-slate-900 mt-6 mb-2">Délégué à la Protection des Données (DPO)</h2>
          <p>
            <strong>Simon YARAMIS</strong>, désigné officiellement DPO de DoctoDays
            conformément à l'article 37 du RGPD.<br />
            Contact :{" "}
            <a className="text-emerald-700 underline" href="mailto:privacy@doctodays.com">
              privacy@doctodays.com
            </a>
          </p>
          <p>
            Vous pouvez exercer vos droits RGPD directement depuis votre espace
            personnel ("Exporter mes données", "Supprimer mon compte") ou en
            contactant le DPO. Délai de réponse : 1 mois maximum.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-slate-900 mt-6 mb-2">Propriété intellectuelle</h2>
          <p>
            L'ensemble du site (architecture, contenus, marques, logos, photographies, code) est
            protégé. Toute reproduction sans autorisation écrite de DoctoDays est interdite.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-slate-900 mt-6 mb-2">Réclamation</h2>
          <p>
            Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une
            réclamation auprès de la CNIL :{" "}
            <a className="text-emerald-700 underline" href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">
              www.cnil.fr
            </a>.
          </p>
        </section>

        <div className="mt-10 text-sm">
          <Link to="/privacy" className="text-emerald-700 hover:underline mr-4">
            Politique de confidentialité
          </Link>
          <Link to="/terms" className="text-emerald-700 hover:underline">
            Conditions Générales d'Utilisation
          </Link>
        </div>
      </main>
    </div>
  );
}
